<template>
  <div class="sidebar-container" :class="{ 'sidebar-hidden': isCollapsed }">
    <!-- 侧边栏内容 -->
    <div class="sidebar">
      <!-- 顶部标题和搜索区域 -->
      <div class="sidebar-header">
        <div class="logo">病虫害捕手</div>
        <div class="header-icons">
          <!-- 右上角的折叠按钮 -->
          <img class="collapse-icon" @click="toggleSidebar" src="@/assets/icons/closeSidebar.png">
        </div>
      </div>

      <!-- 病害分析链接 -->
      <div class="disease-analysis-container">
        <router-link to="/disease-analysis" class="disease-analysis-link">
          <img class="analysis-icon" src="@/assets/icons/analysis.png">
          <span>病害分析</span>
        </router-link>
      </div>

      <!-- 新建对话按钮 -->
      <div class="new-chat-container">
        <button class="new-chat-button" @click="newChat">
          <img class="new-chat-icon" src="@/assets/icons/newChat.png">
          <span>新建对话</span>
        </button>
      </div>
      
      <!-- 底部区域 -->
      <div class="sidebar-footer">
        <!-- 用户信息显示 -->
        <div v-if="!isPending && currentUser" class="user-info-container">
          <div class="user-info">
            <div class="user-avatar">{{ getInitials(currentUser.name || currentUser.email) }}</div>
            <div class="user-details">
              <div class="user-name">{{ currentUser.name || currentUser.email }}</div>
              <div class="user-email" v-if="currentUser.name">{{ currentUser.email }}</div>
            </div>
          </div>
        </div>
        
        <!-- 登录/登出按钮 -->
        <div class="auth-container">
          <div v-if="isPending" class="loading-container">
            <span>正在加载用户信息...</span>
          </div>
          <button v-else-if="currentUser" class="logout-button" @click="handleLogout">
            <img class="logout-icon" src="@/assets/icons/logout.png">
            <span>退出登录</span>
          </button>
        </div>
      </div>
    </div>

    <!-- 当侧边栏隐藏时，显示在左上角的展开按钮 -->
    <div v-if="isCollapsed" class="expand-button" @click="toggleSidebar">
      <img class="expand-icon" src="@/assets/icons/openSidebar.png">
    </div>
  </div>
</template>

<script>
import { authClient, getLoginUrl, signOut } from '@/utils/auth-client.js';

export default {
  name: 'AppSidebar',
  data() {
    return {
      isCollapsed: false,
      loginUrl: getLoginUrl()
    }
  },
  computed: {
    // 使用Better Auth的session
    session() {
      try {
        const sessionHook = authClient.useSession();
        return sessionHook.value;
      } catch (error) {
        console.error('Sidebar获取session失败:', error);
        return null;
      }
    },
    isPending() {
      try {
        const sessionHook = authClient.useSession();
        return sessionHook.value?.isPending || false;
      } catch (error) {
        return false;
      }
    },
    // 获取当前用户信息
    currentUser() {
      if (this.session?.data?.user) {
        return this.session.data.user;
      }
      return null;
    }
  },
  methods: {   
    toggleSidebar() {
      this.isCollapsed = !this.isCollapsed;
      // 通知父组件侧边栏状态已变化
      this.$emit('sidebar-toggle', this.isCollapsed);
    },
    newChat() {
      // 触发新建对话事件
      this.$emit('new-chat');
    },
    async handleLogout() {
      // 确认登出
      if (confirm('确定要退出登录吗？')) {
        try {
          const success = await signOut();
          if (success) {
            // 登出成功，跳转到登录页
            window.location.href = this.loginUrl;
          } else {
            alert('登出失败，请重试');
          }
        } catch (error) {
          console.error('登出失败:', error);
          alert('登出失败，请重试');
        }
      }
    },
    getInitials(name) {
      if (!name) return 'U';
      const names = name.split(' ');
      if (names.length >= 2) {
        return (names[0][0] + names[1][0]).toUpperCase();
      }
      return name[0].toUpperCase();
    }
  }
}
</script>

<style scoped>
.sidebar-container {
  position: relative;
  height: 100vh;
  transition: all 0.3s ease;
}

.sidebar-hidden .sidebar {
  width: 0;
  overflow: hidden;
}

.sidebar {
  width: 100%;
  height: 100vh;
  background-color: #F3F3F3;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  transition: width 0.3s ease;
}

.sidebar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logo {
  margin-top: 47px;
  margin-left: 45px;
  width: 120px;
  height: 33px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 24px;
  color: #303030;
  line-height: 33px;
  text-align: left;
  font-style: normal;
}

.header-icons {
  display: flex;
  align-items: center;
  margin-right: 54px;
  margin-top: 44px;
}

.search-icon,
.menu-icon,
.collapse-icon {
  color: #666;
  cursor: pointer;
}

.collapse-icon {
  font-size: 14px;
}

.user-info-section {
  padding: 10px 45px;
  margin-bottom: 20px;
}

.user-welcome {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.welcome-text {
  font-size: 12px;
  color: #999;
  margin-bottom: 4px;
}

.user-name {
  font-size: 14px;
  font-weight: 500;
  color: #303030;
}

.expand-button {
  position: absolute;
  top: 44px;
  left: 20px;
  width: 30px;
  height: 30px;
  background-color: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 100;
}

.expand-icon {
  color: #666;
}

.new-chat-container {
width: 228px;
  height: 50px;
  background: #FFFFFF;
  border-radius: 10px;
  display: flex;
  text-align: center;
  margin: 10px auto;
}

.new-chat-button {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 8px 16px;
  background-color: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  cursor: pointer;
}

.new-chat-button span {
  width: 64px;
    height: 22px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #303030;
    line-height: 22px;
    text-align: right;
    font-style: normal;
}

.disease-analysis-container {
  width: 228px;
  height: 50px;
  background: #FFFFFF;
  border-radius: 10px;
  display: flex;
  text-align: center;
  margin: 10px auto;
}

.disease-analysis-link {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 8px 16px;
  background-color: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  text-decoration: none;
  cursor: pointer;
  transition: background-color 0.2s;
}

.disease-analysis-link:hover {
  background-color: #e9e9e9;
}

.disease-analysis-link span {
  width: 64px;
  height: 22px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #303030;
  line-height: 22px;
  text-align: right;
  font-style: normal;
}

.analysis-icon {
  width: 16px;
  height: 16px;
}

.sidebar-footer {
  margin-top: auto;
  padding: 20px 0;
}

.user-info-container {
  margin-bottom: 10px;
  padding: 0 20px;
}

.user-info {
  display: flex;
  align-items: center;
  padding: 10px;
  background: #FFFFFF;
  border-radius: 10px;
  border: 1px solid #e0e0e0;
}

.user-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: #249745;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  font-weight: 600;
  font-size: 14px;
}

.user-details {
  flex: 1;
  min-width: 0;
}

.user-name {
  font-size: 14px;
  font-weight: 500;
  color: #303030;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.user-email {
  font-size: 12px;
  color: #666;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.auth-container {
  width: 228px;
  margin: 0 auto;
}

.loading-container {
  text-align: center;
  padding: 15px;
  color: #666;
  font-size: 14px;
}

.logout-button {
  width: 100%;
  height: 50px;
  background: #FFFFFF;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 8px 16px;
  border: 1px solid #e0e0e0;
  cursor: pointer;
  transition: background-color 0.2s;
  text-decoration: none;
  margin-bottom: 10px;
}

.logout-button:hover {
  background-color: #f5f5f5;
}

.logout-button span {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #666;
  line-height: 22px;
}

.logout-icon,
.login-icon {
  width: 16px;
  height: 16px;
}
</style>